/**
 * Deterministic Indonesian date formatter. Avoids `toLocaleDateString`
 * because Node's ICU and the browser's Intl can emit slightly different
 * strings (notably U+202F vs U+0020 separators), which causes hydration
 * mismatches inside Suspense boundaries — manifesting as React #419.
 *
 * Operates in UTC so SSR (often UTC) and client always agree.
 */

const SHORT_MONTHS_ID = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "Mei",
  "Jun",
  "Jul",
  "Agu",
  "Sep",
  "Okt",
  "Nov",
  "Des",
] as const;

const LONG_MONTHS_ID = [
  "Januari",
  "Februari",
  "Maret",
  "April",
  "Mei",
  "Juni",
  "Juli",
  "Agustus",
  "September",
  "Oktober",
  "November",
  "Desember",
] as const;

export const formatPublicationDate = (
  isoDateString: string | null,
  variant: "short" | "long" = "short",
): string => {
  if (!isoDateString) return "";
  const date = new Date(isoDateString);
  if (Number.isNaN(date.getTime())) return "";
  const day = date.getUTCDate();
  const monthIdx = date.getUTCMonth();
  const year = date.getUTCFullYear();
  const months = variant === "long" ? LONG_MONTHS_ID : SHORT_MONTHS_ID;
  return `${day} ${months[monthIdx]} ${year}`;
};